/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../Button';
import ChevronLeft from '@dtsl/icons/dist/icons/react/ChevronLeft';
import ChevronRight from '@dtsl/icons/dist/icons/react/ChevronRight';
function DatepickerNavigation(_ref) {
  let {
    onPreviousClick,
    onNextClick
  } = _ref;
  useEffect(() => {
    const elements = document.getElementsByClassName('DayPicker-Caption');
    for (var i = 0; i < elements.length; i++) {
      elements[i].setAttribute('aria-level', '1');
    }
  });
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "sib-datepicker-custom-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "react-datepicker__navigation react-datepicker__navigation--previous",
    onClick: () => onPreviousClick(),
    role: "button",
    tabIndex: "0"
  }, /*#__PURE__*/React.createElement("span", {
    className: "react-datepicker__navigation-icon react-datepicker__navigation-icon--previous"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "datepicker-navigation-prevoius",
    icon: /*#__PURE__*/React.createElement(ChevronLeft, null),
    ariaLabel: "Left arrow",
    iconAlone: true,
    label: "Button"
  }))), /*#__PURE__*/React.createElement("span", {
    className: "react-datepicker__current-month"
  }), /*#__PURE__*/React.createElement("div", {
    className: "react-datepicker__navigation react-datepicker__navigation--next",
    onClick: () => onNextClick(),
    role: "button",
    tabIndex: "0"
  }, /*#__PURE__*/React.createElement("span", {
    className: 'react-datepicker__navigation-icon react-datepicker__navigation-icon--next'
  }, /*#__PURE__*/React.createElement(Button, {
    className: "datepicker-navigation-next",
    icon: /*#__PURE__*/React.createElement(ChevronRight, null),
    ariaLabel: "Right arrow",
    iconAlone: true,
    label: "Button"
  })))));
}
DatepickerNavigation.propTypes = {
  onPreviousClick: PropTypes.func.isRequired,
  onNextClick: PropTypes.func.isRequired
};
export default DatepickerNavigation;